export type ClientInfo = {
  id: number;
  razon_social: string;
  nombre_fantasia?: string | null;
  documento: string;
  documento_tipo_id?: number;
  telefono?: string | null;
  email?: string | null;
};

export type ItemRow = {
  id: number;
  description: string;
  quantity: number;
  unitPrice: number;
  unidadMedidaId: number | null;
  impuestoId: number | null;
  descuento?: number;
};

export type NewClientForm = {
  razonSocial: string;
  documento: string;
  telefono?: string;
  email?: string;
  nombreFantasia?: string;
};

export type ClientModalView = "search" | "new" | "sinNombreConfirm";
export type ClientModalContentView = Exclude<ClientModalView, "sinNombreConfirm">;

export type SaasEmpresa = {
  id: number;
  razon_social: string;
  nombre_fantasia?: string | null;
  ruc?: string | null;
};

export type SaasSucursal = {
  id: number;
  codigo: string;
  descripcion: string;
};

export type CatalogoItem = {
  id: number;
  codigo?: string | null;
  descripcion?: string | null;
  tasa?: number | null;
  es_exento?: boolean | null;
};

export type CatalogosResponse = {
  documentoTipos: CatalogoItem[];
  condiciones: CatalogoItem[];
  comprobantes: CatalogoItem[];
  talonarioEstados: CatalogoItem[];
  facturaEstados: CatalogoItem[];
  medios: CatalogoItem[];
  unidades: CatalogoItem[];
  impuestos: CatalogoItem[];
};

export const CREDIT_TERMS = [7, 15, 20, 30, 60, 90];

export type SaasTalonario = {
  id: number;
  timbrado_id: number;
  timbrado_numero?: string | null;
  sucursal_id: number;
  sucursal_descripcion?: string | null;
  sucursal_codigo?: string | null;
  establecimiento: string;
  punto_emision: string;
  serie?: string | null;
  numero_inicial: number;
  numero_final: number;
  numero_actual: number;
  estado_id: number;
};

export type PagoForm = {
  id: number;
  medioPagoId: number | null;
  monto: number;
  referencia: string;
};
